import { render, staticRenderFns } from "./flightList.vue?vue&type=template&id=edb83ea0&"
import script from "./flightList.vue?vue&type=script&lang=ts&"
export * from "./flightList.vue?vue&type=script&lang=ts&"
import style0 from "./flightList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports